import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const mailPackageModule = {
  state: {
    // 郵件包裹種類
    mailPackageTypeList: [],
    // 物流公司下拉選單
    logisticsCompanyList: [],
    // 放置位置下拉選單
    locationList: []
  },
  actions: {
    // 取得郵件包裹列表
    async getMailPackageList({ rootState }, payload) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      // 回到頁面處理
      return baseFetch(
        API.getMailPackageList.url(currentCommunityId),
        API.getMailPackageList.method,
        payload
      )
    },
    // 根據郵件包裹編號取得郵件包裹詳細資訊
    async getMailPackageInfo(_, mailPackageId) {
      // 回到頁面處理
      return baseFetch(
        API.getMailPackageInfo.url(mailPackageId),
        API.getMailPackageInfo.method
      )
    },
    // 新增郵件包裹收件
    async addMailPackage({ rootState }, bodyData) {
      // 回到頁面處理
      const currentCommunityId = rootState.commonModule.currentCommunityId
      return baseFetch(API.addMailPackage.url, API.addMailPackage.method, {
        ...bodyData,
        communityId: currentCommunityId
      })
    },
    // 根據郵件包裹編號修改郵件包裹資訊
    async updateMailPackage(_, { mailPackageId, ...params }) {
      // 回到頁面處理
      return baseFetch(
        API.updateMailPackage.url(mailPackageId),
        API.updateMailPackage.method,
        params
      )
    },
    // 郵件包裹退貨申請
    async returnMailPackage(_, { mailPackageId, ...bodyData }) {
      // 回到頁面處理
      return baseFetch(
        API.returnMailPackage.url(mailPackageId),
        API.returnMailPackage.method,
        bodyData
      )
    },
    // 郵件包裹退貨完成
    async returnCompleteMailPackage(_, mailPackageId) {
      // 回到頁面處理
      return baseFetch(
        API.returnCompleteMailPackage.url(mailPackageId),
        API.returnCompleteMailPackage.method
      )
    },
    // 領取郵件包裹
    async pickupMailPackage(_, { mailPackageId, ...params }) {
      // 回到頁面處理
      return baseFetch(
        API.pickupMailPackage.url(mailPackageId),
        API.pickupMailPackage.method,
        params
      )
    },
    // 根據戶別編號取得住戶列表
    async getMailPackageTypeList({ commit }) {
      try {
        const res = await baseFetch(
          API.getMailPackageTypeList.url,
          API.getMailPackageTypeList.method
        )
        if (!res.isError && res.data) {
          commit('SET_MAILPACKAGETYPE_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得物流公司列表
    async getLogisticsCompanyList({ commit }) {
      try {
        const res = await baseFetch(
          API.getLogisticsCompanyList.url,
          API.getLogisticsCompanyList.method
        )
        if (!res.isError && res.data) {
          commit('SET_LOGISTICSCOMPANY_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得放置位置列表
    async getLocationList({ commit, rootState }) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.getLocationList.url,
          API.getLocationList.method,
          { communityId: currentCommunityId }
        )
        if (!res.isError && res.data) {
          commit('SET_LOCATION_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 根據社區編號取得未領取郵件包裹列表
    async getUnclaimedMailPackageList({ rootState }) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      // 回到頁面處理
      return baseFetch(
        API.getUnclaimedMailPackageList.url(currentCommunityId),
        API.getUnclaimedMailPackageList.method
      )
    },
    // 發送郵件包裹推播通知
    async sendNotification(_, bodyData) {
      // 回到頁面處理
      return baseFetch(
        API.sendNotification.url,
        API.sendNotification.method,
        bodyData
      )
    },
    // 根據個人郵件包裹條碼取得郵件包裹資訊
    async getMailPackageInfoByBarcode(_, { barcode, ...params }) {
      // 回到頁面處理
      return baseFetch(
        API.getMailPackageInfoByBarcode.url(barcode),
        API.getMailPackageInfoByBarcode.method,
        params
      )
    },
    // 根據個人郵件包裹條碼領取郵件包裹
    async pickupMailPackageByBarcode(_, { barcode, ...params }) {
      // 回到頁面處理
      return baseFetch(
        API.pickupMailPackageByBarcode.url(barcode),
        API.pickupMailPackageByBarcode.method,
        params
      )
    },
    // 根據個人郵件包裹條碼退貨申請郵件包裹
    async returnMailPackageByBarcode(_, { barcode, ...params }) {
      // 回到頁面處理
      return baseFetch(
        API.returnMailPackageByBarcode.url(barcode),
        API.returnMailPackageByBarcode.method,
        params
      )
    }
  },
  mutations: {
    SET_MAILPACKAGETYPE_LIST(state, payload) {
      state.mailPackageTypeList = payload
    },
    SET_LOGISTICSCOMPANY_LIST(state, payload) {
      state.logisticsCompanyList = payload
    },
    SET_LOCATION_LIST(state, payload) {
      state.locationList = payload
    }
  },
  getters: {
    getMailPackageTypeList: (state) => state.mailPackageTypeList,
    getLogisticsCompanyList: (state) => state.logisticsCompanyList,
    getLocationList: (state) => state.locationList
  },
  namespaced: true
}

export default mailPackageModule
